import { withDependencies } from '@wix/thunderbolt-ioc'
import type { ESMLoadRegistrar } from './types'

export const ESMLoadRegistrarFactory = withDependencies(
	[],
	(): ESMLoadRegistrar => {
		// Global cache to prevent duplicate loads of the same URL across all ESM loader instances
		const loadModuleCache = new Map<string, Promise<any>>()
		return {
			loadModuleWithCache: <T = any>(url: string, loadFn: () => Promise<T>): Promise<T> => {
				// Check if this URL is already being loaded or has been loaded
				const cachedPromise = loadModuleCache.get(url)
				if (cachedPromise) {
					return cachedPromise as Promise<T>
				}

				const loadPromise = loadFn().catch((error) => {
					loadModuleCache.delete(url)
					throw error
				})

				// Cache the promise so concurrent calls wait for the same load
				loadModuleCache.set(url, loadPromise)

				return loadPromise
			},
		}
	}
)
